import apiClient from "api/api-client";
import { QUERY_KEYS } from "constants/query-keys";
import { useList } from "hooks/use-list";
import { ApiListResponse } from "types/api";
import { PublicProgram } from "types/program";

export const usePublicPrograms = (limitNumber?: number) => {
  return useList({
    keys: [QUERY_KEYS.programs],
    queryFn: async ({ offset, limit, filters }) => {
      return apiClient.get<ApiListResponse<PublicProgram>>("/public/programs", {
        params: { offset, limit: limitNumber ?? limit, ...filters },
      });
    },
    limit: limitNumber,
  });
};
